import { Component, Listen, State, h, JSX, Host, Prop, Watch } from "@stencil/core";
import { injectHistory, LocationSegments, RouterHistory } from '@stencil/router';
import { MESSAGES } from "../constants";
import { BelimoError } from "./type";

@Component({
  tag: 'app-error-messages',
  shadow: false,
})
export class AppErrorMessages {
  @Prop({mutable: true}) history: RouterHistory;
  @Prop({mutable: true}) location: LocationSegments;
  @State() errors: BelimoError[] = [];

  @Watch('location')
  public async locationChanged(newValue: LocationSegments, oldValue: LocationSegments): Promise<void> {
    const oldCompare = JSON.stringify([oldValue?.pathname, oldValue?.search]);
    const newCompare = JSON.stringify([newValue.pathname, newValue.search]);
    if (oldCompare !== newCompare) {
      this.errors = [];
    }
  }

  @Listen('belimoError', { target: 'document' })
  public watchForErrors({ detail }: { detail: BelimoError }): void {
    this.errors = [...this.errors, detail];
  }

  public render(): JSX.Element {
    const noConnection = this.errors.every((x) => x.type === 'noConnection');
    return (<Host>
      {this.errors.length > 0 &&
      <div class="no-results no-results--app-error">
        <div class="no-results__icon">
          <div class="no-results__close" onClick={() => this.errors = []}>
            <belimo-svg-sprite svgId={'x'}/>
          </div>
          <belimo-svg-sprite svgId={'no-internet'}/>
        </div>
        <div class="no-results__text">
          <h3>
            {noConnection ? 'Offline' : <belimo-i18n messageId={MESSAGES.ERROR_TITLE} />}
          </h3>
          <belimo-i18n messageId={noConnection ? MESSAGES.NO_NETWORK_ERROR_MESSAGE : MESSAGES.UNRECOVERABLE_ERROR_MESSAGE} />
        </div>
      </div>}
    </Host>);
  }

}

injectHistory(AppErrorMessages);
